<template>
	<section class="small-12 columns addForm addPurchase border-left animated fadeInRightBig" v-if="openMenu" v-bind:class="{ active: openMenu }">
		<div class="small-12 formTitle border-bottom">
			<h2 class="small-12 flex vertical-align">
				<i class="material-icons-outlined transition" @click="closeMenu()" v-tooltip="'Cancel'">cancel</i>
				Purchase Details
			</h2>
		</div>
		<div class="small-12 formBody" v-if="property">
			<div class="small-12 form">
				<div class="small-12 image borderRadius8">
					<picture class="flex small-12 justify-center">
						<img :src="vector_image" alt="House Card with Lots of Blues and Purples">
					</picture>
				</div>
				<ul class="small-12 flex">
					<li class="small-12">
						<label class="small-12">Purchase Price<em class="cRed">*</em></label>
						<input type="number" name="purchased_at" min="1" step="any" placeholder="0.00" v-model="purchase_price">
					</li>
					<li class="small-12">
						<label class="small-12">Date Purchased<em class="cRed">*</em></label>
						<input type="date" placeholder="mm/dd/yyyy" name="purchased_date" v-model="purchase_date">
					</li>
					<li class="small-12 action">
						<a class="blueButton small-12 flex justify-center borderRadius8 vertical-align" @click="createThePurchase()">
							Update Purchase Details
						</a>
					</li>
				</ul>
			</div>
		</div>
	</section>
</template>

<script>

	// Import firebase
	import { propertiesModel } from '@/firebase/firebase-config'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'
	import { PropertiesRepository } from '@/components/mixins/repositories/properties/PropertiesRepository'
	import { PropertyPurchasesRepository } from '@/components/mixins/repositories/properties/PropertyPurchasesRepository'
	import { MoneyConversions } from '@/mixins/filters/MoneyConversions'

	export default {

		/*
		** Set the component name
		*/

		name: 'AddPurchase',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
			SpinnerMethods,
			PropertiesRepository,
			PropertyPurchasesRepository,
			MoneyConversions

		],

		/*
		**  Set the props
		*/

		props: {

			menu_action: {
				type: Boolean,
				default: false
			},
			purchase: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			openMenu: false,
			vector_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Fhouse-credit-card.svg?alt=media&token=68ec7af3-09bc-414f-b1ee-28f5e4da6b58',
			property: null,
			purchase_date: null,
			purchase_price: null,
			validDate: false

		}),

		/*
		**  Watch em'
		*/

		watch: {

			menu_action: {

				immediate: true, // Load on created
				handler(menu_action) {

					if (menu_action) this.openMenu = true;

				}

			},

			property: {

				immediate: true, // Load on created
				handler(property) {

					// Set the ID
					if (property) this.new_purchase.relationships.property = property.id;

					// Format the date
					if (property && property.attributes.purchase.date) this.formatDate();

					// Format the price
					if (property && property.attributes.purchase.price) this.formatPrice(); 

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	// Bind to the doc
			this.$bind('property', propertiesModel.doc(this.$route.params.id));

        },

        /*
		**  Set up the methods
		*/

		methods: {

			closeMenu: function() {

				// Close the menu
				this.openMenu = false;

				// Emit the event
				this.$emit('closeAddPurchaseMenu', true);

			},
			createThePurchase: function() {

				// Show the spinner
				this.showSpinner();

				// Validate the entries
				let validated = this.validate();

				if (!validated) {

					// Hide the spinner
					this.hideSpinner();

					this.$swal('Uh Oh!', 'Please make sure to fill out all required fields before updating the details.', 'error');

					return;

				}

				// Check if date is valid
				this.validDateCheck();

				if (!this.validDate) {

					// Hide the spinner
					this.hideSpinner();

					this.$swal('Uh Oh!', 'Please make sure to enter in a valid date within the yyyy-mm-dd format.', 'error');

					return;

				}
			
				// If purchase exists
				if (this.purchase) {

					// Convert the price
					this.purchase_price = this.convertDollarsToCents(this.purchase_price);

					// Convert the prop
					this.purchase_date = moment(this.purchase_date).unix();

					// Update the purchase
					this.updatePurchase();

					// Update the property
					this.updatePurchasePrice();

					// Reset the props
					this.formatDate();
					this.formatPrice();

				} else {

					// Format the price
					this.purchase_price = this.convertDollarsToCents(this.purchase_price);

					// Format the date
					this.purchase_date = moment(this.purchase_date).unix();

					// Set the new_purchase props
					this.new_purchase.attributes.purchase_price = this.purchase_price;
					this.new_purchase.attributes.purchase_date = this.purchase_date;

					// Create the new purchase
					this.createPurchase();

					// Update property
					this.updatePurchasePrice();

					// Reset the props
					this.formatDate();
					this.formatPrice();

				}

			},

			validate: function() {

				// Validate the required fields
				if (this.purchase_price == 0) return false;
				if (this.purchase_date == null || this.purchase_date.length == 0) return false;

				return true;

			},

			validDateCheck: function() {

				// Set the var
				let date = moment(this.purchase_date);

				// Check if valid
				if (date.isValid()) this.validDate = true;

			},

			formatDate: function() {

				this.purchase_date = moment(this.property.attributes.purchase.date).format('YYYY-MM-DD');

			},

			formatPrice: function() {

				this.purchase_price = this.property.attributes.purchase.price / 100;

			}

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		}

	}

</script>